import React from 'react'

export default function FuzzFilter() {
    return (
        <filter id="fuzzFilter" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="0 10" />
        </filter>
    )
}
